// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_gL","advertCardNum":"c-a_gM"};